import { batch } from "react-redux";
import { actions } from 'react-redux-form';

import {
    hrDetailsFormModel,
    getHRDetails,
    getCostCenterDropdown,
    getStatusDropdown,
    getLineManagerDropdown,
    getApproverCostCenterAuthorizerDropdown,
    getApproverWirelineDropdown,
    getLocationAddressDropdown,
    getFirstLineManagerDropdownList,
    getLocationAddressDropdownList,
    getRoleDropdown,
    resetFetchingHrDetails,
    setLineManagerLoading,
    setLocationLoading,
    resetForm
} from "../../../../constants/model-reducers/external/manage-user/form/manage-user-form.settings";
import { httpPost, httpGet } from "../../../../utils/api.utils";
import { convertToLocalDateToUTCDate, transformData_KeyValue, trueFalseToBoolean, convertDateStringToDateFormat } from "../../../../utils/helpers.utils";
import { TRANSLATIONS, STRING_VALUES } from '../../../../utils/constant.utils';

export const hrDetailsInitialFormState = hrDetailsFormModel;

const defaultState = () => ({
    fetchingHrDetails: true,
    costCenterDropdown: [],
    statusDropdown: [],
    lineManagerDropdown: [],
    approverCostCenterAuthorizerDropdown: [],
    approverWirelineDropdown: [],
    locationAddressDropdown: [],
    lineManagerDropdownList: [],
    locationAddressDropdownList: [],
    roleDropdown: [],
    lineManagerPage: 1,
    isLineManagerLoading: false,
    hasMoreLineManager: true,
    locationPage: 1,
    isLocationLoading: false,
    hasMoreLocation: true
});

const initialState = defaultState();

export const hrDetailsActions = {
    saveManageHRForm: (empId, validate) => async (dispatch, state) => {
        let locale = state().translation.locale;
        if (locale === null || locale === '')
            locale = TRANSLATIONS['defaultLocaleLanguage'];

        try {
            const { manageUserHrDetailsForm } = state().form;
            const {statusId, isVIP, approverCostCenterAuthorizer, approverWireline, costCenterId,
                firstLineManagerHrId, locationId, employeeId, userId
            } = manageUserHrDetailsForm;
            const { userCostAllocation } = state().manageUserCostAllocation;

            var userCostAllocationData = userCostAllocation.datatable.length > 0 ? userCostAllocation.datatable[0].dataItem : [];

            const formData = {
                ...manageUserHrDetailsForm,
                statusId: parseInt(statusId),
                isVIP: isVIP ? 1 : 0,
                costCenterApprover: approverCostCenterAuthorizer !== STRING_VALUES.stringZero && approverCostCenterAuthorizer !== STRING_VALUES.stringNull ?
                    trueFalseToBoolean(approverCostCenterAuthorizer) : null,
                wirelineApprover: approverWireline !== STRING_VALUES.stringZero && approverWireline !== STRING_VALUES.stringNull ?
                    trueFalseToBoolean(approverWireline) : null,
                costCenterId: parseInt(costCenterId),
                lineManagerId: firstLineManagerHrId,
                locationAddressId: parseInt(locationId) != 0 ? parseInt(locationId) : null,
                UserCostAllocations: userCostAllocationData,
                employeeId: employeeId,
                userId: userId
            }

            var result = await saveManageHR(empId, validate, formData);

            if (result.success && validate == false) {
                dispatch(actions.load("manageUserHrDetailsForm", manageUserHrDetailsForm));
            }

            if (result.success == false) {
                if (result.propertyName == "hrSapId") {
                    dispatch(actions.setErrors("manageUserHrDetailsForm.hrSapId", true));
                }
                if (result.propertyName == "emailAddress") {
                    dispatch(actions.setErrors("manageUserHrDetailsForm.emailAddress", true));
                }
                if (result.propertyName == "userCostAllocations") {
                    dispatch(actions.setErrors("manageUserCostAllocationForm.CostCodePercent", true));
                }

            }

            return result;
        }
        catch (e) {
            return e;
        }
    },
    getHrLineManager: (pageIndex=1, searchString='') => async(dispatch,state) =>{
        var lineManagerData = await getLineManagerList(pageIndex, searchString, dispatch);

        dispatch({
            type: getFirstLineManagerDropdownList,
                payload: {
                    lineManagerData: lineManagerData.lineManager,
                    lineManagerList: lineManagerData.lineManagerList,
                    page: pageIndex
                }
        });
    },
    getHrLocationAddress: (pageIndex=1, searchString='')=> async(dispatch,state)=>{
        var locationAddressData = await getLocationAddressList(pageIndex, searchString, dispatch);
         dispatch({
            type: getLocationAddressDropdownList,
            payload: {
                locationData: locationAddressData.locationAddress,
                lineManagerDropdown: locationAddressData.locationAddressList,
                locationPages: pageIndex
            }
        });
    },
    getHRDetails: (employeeId) => async (dispatch, state) => {
        dispatch({
            type: getHRDetails,
            data: {
                fetching: true
            }
        });       
        var statuses = await getStatus();
        var approverCCAuthorizer = await getApproverCostCenterAuthorizer();
        var approverWireline = await getApproverWireline();       
        
        var roleData = await getRoleList();
        if (!employeeId || employeeId == 0) {
            batch(() => {
                dispatch({
                    type: getStatusDropdown,
                    data: statuses
                });
                dispatch({
                    type: getApproverCostCenterAuthorizerDropdown,
                    data: approverCCAuthorizer
                });
                dispatch({
                    type: getApproverWirelineDropdown,
                    data: approverWireline
                });                
                dispatch({
                    type: getRoleDropdown,
                    data: roleData
                });

                dispatch({
                    type: getHRDetails,
                    data: {
                        fetching: false
                    }
                });
                
            });
        }
        else {
            var result = await httpGet(`external/manageUser/getHRDetails/${employeeId}`);
            var data = result.data;

            if (data) {
                batch(() => {
                    dispatch({
                        type: getStatusDropdown,
                        data: statuses
                    });
                    dispatch({
                        type: getApproverCostCenterAuthorizerDropdown,
                        data: approverCCAuthorizer
                    });
                    dispatch({
                        type: getApproverWirelineDropdown,
                        data: approverWireline
                    });

                    dispatch({
                        type: getRoleDropdown,
                        data: roleData
                    });

                    dispatch(actions.load('manageUserHrDetailsForm.employeeId', data.EmployeeId));
                    dispatch(actions.load('manageUserHrDetailsForm.userId', data.UserId));
                    dispatch(actions.load('manageUserHrDetailsForm.hrSapId', data.HrSapId));
                    dispatch(actions.load('manageUserHrDetailsForm.firstName', data.FirstName));
                    dispatch(actions.load('manageUserHrDetailsForm.lastName', data.LastName));
                    dispatch(actions.load('manageUserHrDetailsForm.middleInitial', data.MiddleInitial));
                    dispatch(actions.load('manageUserHrDetailsForm.emailAddress', data.EmailAddress));
                    dispatch(actions.load('manageUserHrDetailsForm.jobTitle', data.JobTitle));
                    dispatch(actions.load('manageUserHrDetailsForm.statusId', data.StatusId));
                    dispatch(actions.load('manageUserHrDetailsForm.hireDate', data.HireDate ? convertDateStringToDateFormat(data.HireDate) : ''));
                    dispatch(actions.load('manageUserHrDetailsForm.dateLeft', data.DateLeft ? convertDateStringToDateFormat(data.DateLeft) : ''));
                    dispatch(actions.load('manageUserHrDetailsForm.isVIP', data.IsVIP));
                    dispatch(actions.load('manageUserHrDetailsForm.approverCostCenterAuthorizer', String(data.CostCenterApprover ?? false)));
                    dispatch(actions.load('manageUserHrDetailsForm.approverWireline', String(data.WirelineApprover ?? false)));

                    dispatch(actions.load('manageUserHrDetailsForm.costCenterDisplay', data.CostCenter.CostCenter));
                    dispatch(actions.load('manageUserHrDetailsForm.costCenterId', data.CostCenter.CostCodeId));
                    dispatch(actions.load('manageUserHrDetailsForm.costCenterAuthorizer', data.CostCenter.CostCenterAuthorizer ?? ""));
                    dispatch(actions.load('manageUserHrDetailsForm.firstLineManagerHrId', data.LineManager?.LineManagerHrId));
                    dispatch(actions.load("manageUserHrDetailsForm.firstLineManagerFullName", data.LineManager?.FullName));
                    dispatch(actions.load("manageUserHrDetailsForm.firstLineManagerEmailAddress", data.LineManager?.EmailAddress));
                    dispatch(actions.load("manageUserHrDetailsForm.firstLineManagerStatus", data.LineManager?.Status));
                    dispatch(actions.load("manageUserHrDetailsForm.secondLineManagerHrId", data.LineManager?.SecondLineManager?.LineManagerHrId));
                    dispatch(actions.load("manageUserHrDetailsForm.secondLineManagerFullName", data.LineManager?.SecondLineManager?.FullName));
                    dispatch(actions.load("manageUserHrDetailsForm.secondLineManagerEmailAddress", data.LineManager?.SecondLineManager?.EmailAddress));
                    dispatch(actions.load("manageUserHrDetailsForm.secondLineManagerStatus", data.LineManager?.SecondLineManager?.Status));
                    dispatch(actions.load('manageUserHrDetailsForm.locationId', data.LocationAddress.LocationId));
                    dispatch(actions.load('manageUserHrDetailsForm.locationSiteId', data.LocationAddress.LocationSiteId));
                    dispatch(actions.load("manageUserHrDetailsForm.address1", data.LocationAddress.Address1));
                    dispatch(actions.load("manageUserHrDetailsForm.address2", data.LocationAddress.Address2));
                    dispatch(actions.load("manageUserHrDetailsForm.locationType", data.LocationAddress.LocationType));
                    dispatch(actions.load("manageUserHrDetailsForm.city", data.LocationAddress.City));
                    dispatch(actions.load("manageUserHrDetailsForm.state", data.LocationAddress.State));
                    dispatch(actions.load("manageUserHrDetailsForm.country", data.LocationAddress.Country));
                    dispatch(actions.load("manageUserHrDetailsForm.zip", data.LocationAddress.Zip));
                    dispatch(actions.load("manageUserHrDetailsForm.roleId", data.RoleId));

                    setCostCenter(dispatch, data.CostCenter);
                    setLineManager(dispatch, data.LineManager);
                    setLocationAddress(dispatch, data.LocationAddress)

                    dispatch({
                        type: getHRDetails,
                        data: {
                            fetching: false
                        }
                    });
                });

                return data;
            }
        }
    },    
    selectCostCenter: (value, propsName) => (dispatch, state) => {
        if (value == '') {
            batch(() => {
                resetCostCenter(dispatch);
            });
        }
        else {
            setCostCenter(dispatch, value);
        }
    },
    selectLineManager: (propsName, value) => async (dispatch, state) => {
        const { lineManagerDropdown } = state().manageUserHrDetails;

        if (value == '' || lineManagerDropdown?.length === 0) {
            batch(() => {
                resetLineManager(dispatch);
            });
        }
        else {
            const result = await getLineManagerList(1, value, dispatch)
            const lineManager = result.lineManagerList[0];

            await setLineManager(dispatch, lineManager, value);

            return lineManager;
        }
    },
    selectLocationSite: (propsName,value) => async (dispatch, state) => {
        const { locationAddressDropdown } = state().manageUserHrDetails;

        if (value == '' || locationAddressDropdown?.length === 0) {
            batch(() => {
                resetLocationAddress(dispatch);
            });
        }
        else {
            const result = await getLocationAddressList(1, value, dispatch);
            const locationAddress = result.locationAddressList[0];
            setLocationAddress(dispatch, locationAddress, value);

            return locationAddress;
        }
    },
    resetmanageUserHrDetailsForm: () => (dispatch) => {       
        batch(() => {
            dispatch(actions.change('manageUserHrDetailsForm.employeeId', hrDetailsFormModel.employeeId));
            dispatch(actions.change('manageUserHrDetailsForm.userId', hrDetailsFormModel.userId));            
            dispatch(actions.change('manageUserHrDetailsForm.hireDate', hrDetailsFormModel.hireDate));
            dispatch(actions.change('manageUserHrDetailsForm.dateLeft', hrDetailsFormModel.dateLeft));
            dispatch(actions.change('manageUserHrDetailsForm.isVIP', hrDetailsFormModel.isVIP));
            dispatch(actions.change('manageUserHrDetailsForm.approverCostCenterAuthorizer', hrDetailsFormModel.approverCostCenterAuthorizer));
            dispatch(actions.change('manageUserHrDetailsForm.approverWireline', hrDetailsFormModel.approverWireline));            
            dispatch(actions.resetErrors("manageUserHrDetailsForm.hrSapId"));
            dispatch(actions.resetErrors("manageUserHrDetailsForm.emailAddress"));
            dispatch(actions.resetErrors("manageUserCostAllocationForm.CostCodePercent"));
            resetLocationAddress(dispatch)
            resetCostCenter(dispatch);
            resetLineManager(dispatch);
            resetRole(dispatch);
            dispatch(actions.reset('manageUserHrDetailsForm'));
            dispatch(actions.reset('manageUserHrDetailsForm.costCenterId'));
            dispatch(actions.reset('manageUserHrDetailsForm.firstLineManagerHrId'));
            dispatch(actions.reset('manageUserHrDetailsForm.hrSapId'));
            dispatch(actions.reset('manageUserHrDetailsForm.firstName'));
            dispatch(actions.reset('manageUserHrDetailsForm.lastName'));
            dispatch(actions.reset('manageUserHrDetailsForm.middleInitial'));
            dispatch(actions.reset('manageUserHrDetailsForm.statusId'));
            dispatch(actions.reset("manageUserHrDetailsForm.emailAddress"));
            dispatch(actions.reset('manageUserHrDetailsForm.jobTitle'));
      
        });
        dispatch({
            type: resetForm
        })
    },

    resetHrLineManagerDetails: () => (dispatch) => {
        dispatch(actions.reset('manageUserHrDetailsForm.firstLineManagerStatus'));
        dispatch(actions.reset('manageUserHrDetailsForm.firstLineManagerFullName'));
        dispatch(actions.reset('manageUserHrDetailsForm.firstLineManagerEmailAddress'));
        dispatch(actions.reset('manageUserHrDetailsForm.secondLineManagerHrId'));
        dispatch(actions.reset('manageUserHrDetailsForm.secondLineManagerFullName'));
        dispatch(actions.reset('manageUserHrDetailsForm.secondLineManagerEmailAddress'));
        dispatch(actions.reset("manageUserHrDetailsForm.secondLineManagerStatus"));
    },

    resetfetchingHrDetails: () => ({
        type: resetFetchingHrDetails,
    }),

    resetLocation: () => (dispatch) => {
        resetLocationAddress(dispatch)
    }
}
async function getLocationAddressList(page, searchString, dispatch) {    
    const pageSize=15;  

     dispatch({ 
         type: setLocationLoading, 
        payload: true 
    });

    try {
        let url = `external/manageUser/getLocationAddressDropdownList/${page}/${pageSize}`;
        if(searchString) {
            url += `/${encodeURIComponent(searchString)}`;
        }

        var res = await httpGet(url);
        if (res != null) {
            const transformedData = transformData_KeyValue(res, 'LocationId', 'LocationSiteId');
        return {
            locationAddress: transformedData,
            locationAddressList: res.data, 
        }
        } else {
            return null
        }

    }catch(error) {
            return null
    }finally {
        dispatch({ type: setLocationLoading, payload: false });
    }
}

async function getLineManagerList(page, searchString, dispatch) {    
    const pageSize=15;
        
    dispatch({ 
        type: setLineManagerLoading, 
        payload: true 
    });

    try {
        let url = `external/manageUser/getLineManagerDropdownList/${page}/${pageSize}`;
         if(searchString) {
            url += `/${encodeURIComponent(searchString)}`;
        }
        var res = await httpGet(url);
        if (res != null) {
            const transformedData = transformData_KeyValue(res, 'LineManagerHrId', 'LineManagerHrId', 'FullName');
            return {
                lineManager: transformedData,
                lineManagerList: res.data,
            };
        } else {
            return null;
        }
    } catch (error) {
        return null;
    } finally {
        dispatch({ type: setLineManagerLoading, payload: false });
    }
}

async function getStatus() {
    try {
        var result = await httpGet('external/manageUser/getEmployeeStatusDropdown');
        return result.data;
    }
    catch (e) {
        return [];
    }
}

async function getCostCenter(searchVal) {
    try {
        var result = await httpGet(`external/manageUser/getCostCenterDropdown?searchVal=${searchVal ?? ''}`);
        return result;
    }
    catch (e) {}
}

async function getApproverCostCenterAuthorizer() {
    try {
        var result = await httpGet('external/manageUser/getApproverCostCenterAuthorizerDropdown');
        return result.data;
    }
    catch (e) {
        return [];
    }
}

async function getApproverWireline() {
    try {
        var result = await httpGet('external/manageUser/getApproverWirelineDropdown');
        return result.data;
    }
    catch (e) {
        return [];
    }
}

async function getRoleList() {
    try {
        var result = await httpGet('external/manageUser/getRoleListDropdown');
        return result.data;
    }
    catch (e) {
        return [];
    }
}

async function saveManageHR(employeeId, validate, data) {
    try {
        var result = await httpPost(`external/manageUser/save/${employeeId ?? 0}/${validate ?? 0}`, data);

        if (result.ok === false) {
            throw {
                success: false,
                message: "HR details is not saved. Error encountered while on saving."
            };
        }
        return result;
    }
    catch (e) {
        throw e;
    }
}
function resetRole(dispatch) {
    dispatch(actions.change("manageUserHrDetailsForm.roleId", hrDetailsInitialFormState.roleId));
}

function resetCostCenter(dispatch) {
    dispatch(actions.change("manageUserHrDetailsForm.costCenterDisplay", hrDetailsInitialFormState.costCenterDisplay));
    dispatch(actions.change("manageUserHrDetailsForm.costCenterId", hrDetailsInitialFormState.costCenterId));
    dispatch(actions.change("manageUserHrDetailsForm.costCenterAuthorizer", hrDetailsInitialFormState.costCenterAuthorizer));
    dispatch(actions.resetErrors("manageUserHrDetailsForm.costCenterDisplay"));
}

async function setCostCenter(dispatch,value) {
    if (value) {
        const costCenter= await getCostCenter(value);
        if(costCenter.data.length > 0) {
            batch(() => {
                dispatch(actions.change('manageUserHrDetailsForm.costCenterDisplay', costCenter.data[0].CostCenter));
                dispatch(actions.change('manageUserHrDetailsForm.costCenterId', costCenter.data[0].CostCodeId));
                dispatch(actions.change('manageUserHrDetailsForm.costCenterAuthorizer', costCenter.data[0].CostCenterAuthorizer ?? ""));
            });
        }       
    }
    else {
        batch(() => {
            resetCostCenter(dispatch);
            dispatch(actions.change('manageUserHrDetailsForm.costCenterDisplay', value));
        });
    }
}

function resetLineManager(dispatch) {
    dispatch(actions.change("manageUserHrDetailsForm.firstLineManagerHrId", hrDetailsInitialFormState.firstLineManagerHrId));
    dispatch(actions.change("manageUserHrDetailsForm.firstLineManagerFullName", hrDetailsInitialFormState.firstLineManagerFullName));
    dispatch(actions.change("manageUserHrDetailsForm.firstLineManagerEmailAddress", hrDetailsInitialFormState.firstLineManagerEmailAddress));
    dispatch(actions.change("manageUserHrDetailsForm.firstLineManagerStatus", hrDetailsInitialFormState.firstLineManagerStatus));

    dispatch(actions.change("manageUserHrDetailsForm.secondLineManagerHrId", hrDetailsInitialFormState.secondLineManagerHrId));
    dispatch(actions.change("manageUserHrDetailsForm.secondLineManagerFullName", hrDetailsInitialFormState.secondLineManagerFullName));
    dispatch(actions.change("manageUserHrDetailsForm.secondLineManagerEmailAddress", hrDetailsInitialFormState.secondLineManagerEmailAddress));
    dispatch(actions.change("manageUserHrDetailsForm.secondLineManagerStatus", hrDetailsInitialFormState.secondLineManagerStatus));
}

async function setLineManager(dispatch, lineManager, value) {
    if (lineManager) {
        batch(() => {
            dispatch(actions.change('manageUserHrDetailsForm.firstLineManagerHrId', lineManager.LineManagerHrId));
            dispatch(actions.change("manageUserHrDetailsForm.firstLineManagerFullName", lineManager.FullName));
            dispatch(actions.change("manageUserHrDetailsForm.firstLineManagerEmailAddress", lineManager.EmailAddress));
            dispatch(actions.change("manageUserHrDetailsForm.firstLineManagerStatus", lineManager.Status));

            dispatch(actions.change("manageUserHrDetailsForm.secondLineManagerHrId", lineManager.SecondLineManager?.LineManagerHrId));
            dispatch(actions.change("manageUserHrDetailsForm.secondLineManagerFullName", lineManager.SecondLineManager?.FullName));
            dispatch(actions.change("manageUserHrDetailsForm.secondLineManagerEmailAddress", lineManager.SecondLineManager?.EmailAddress));
            dispatch(actions.change("manageUserHrDetailsForm.secondLineManagerStatus", lineManager.SecondLineManager?.Status));
        });
    }
    else {
        batch(() => {
            resetLineManager(dispatch);
            dispatch(actions.change('manageUserHrDetailsForm.firstLineManagerHrId', value));
        });
    }
}

function resetLocationAddress(dispatch) {
    dispatch(actions.change('manageUserHrDetailsForm.locationId', hrDetailsInitialFormState.locationId));
    dispatch(actions.change('manageUserHrDetailsForm.locationSiteId', hrDetailsInitialFormState.locationSiteId));
    dispatch(actions.change("manageUserHrDetailsForm.address1", hrDetailsInitialFormState.address1));
    dispatch(actions.change("manageUserHrDetailsForm.address2", hrDetailsInitialFormState.address2));
    dispatch(actions.change("manageUserHrDetailsForm.locationType", hrDetailsInitialFormState.locationType));
    dispatch(actions.change("manageUserHrDetailsForm.city", hrDetailsInitialFormState.city));
    dispatch(actions.change("manageUserHrDetailsForm.state", hrDetailsInitialFormState.state));
    dispatch(actions.change("manageUserHrDetailsForm.country", hrDetailsInitialFormState.country));
    dispatch(actions.change("manageUserHrDetailsForm.zip", hrDetailsInitialFormState.zip));
}

function setLocationAddress(dispatch, location, value) {
    if (location) {
        batch(() => {
            dispatch(actions.change('manageUserHrDetailsForm.locationId', location.LocationId));
            dispatch(actions.change('manageUserHrDetailsForm.locationSiteId', location.LocationSiteId));
            dispatch(actions.change("manageUserHrDetailsForm.address1", location.Address1));
            dispatch(actions.change("manageUserHrDetailsForm.address2", location.Address2));
            dispatch(actions.change("manageUserHrDetailsForm.locationType", location.LocationType));
            dispatch(actions.change("manageUserHrDetailsForm.city", location.City));
            dispatch(actions.change("manageUserHrDetailsForm.state", location.State));
            dispatch(actions.change("manageUserHrDetailsForm.country", location.Country));
            dispatch(actions.change("manageUserHrDetailsForm.zip", location.Zip));
        });
    }
    else {
        batch(() => {
            resetLocationAddress(dispatch);
            dispatch(actions.change('manageUserHrDetailsForm.locationSiteId', value));
        });
    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getHRDetails:
            return {
                ...state,
                fetchingHrDetails: action.data.fetching
            }
        case getCostCenterDropdown:
            return {
                ...state,
                costCenterDropdown: action.data
            };
        case getStatusDropdown:
            return {
                ...state,
                statusDropdown: action.data
            };
        case getLineManagerDropdown:
            return {
                ...state,
                lineManagerDropdown: action.data                
            }
        case getApproverCostCenterAuthorizerDropdown:
            return {
                ...state,
                approverCostCenterAuthorizerDropdown: action.data
            }
        case getApproverWirelineDropdown:
            return {
                ...state,
                approverWirelineDropdown: action.data
            }
        case getLocationAddressDropdown:
            return {
                ...state,
                locationAddressDropdown: action.data
            };
        case getFirstLineManagerDropdownList:
            const { lineManagerData, lineManagerList, page } = action.payload;
            const newLineManagerList = Array.isArray(lineManagerData) ? lineManagerData : [];
            return {
                ...state,
                lineManagerDropdownList: page === 1
                    ? newLineManagerList
                    : [...state.lineManagerDropdownList,
                        ...newLineManagerList],
                lineManagerDropdown: lineManagerList,
                hasMoreLineManager: lineManagerData.length > 0,
                lineManagerPage: page
            }
        case getLocationAddressDropdownList:
            const { locationData, lineManagerDropdown, locationPages } = action.payload;
            const newLocationList = Array.isArray(locationData) ? locationData : [];
            return {
                ...state,
                locationAddressDropdownList: locationPages === 1
                    ? newLocationList
                    : [...state.locationAddressDropdownList,
                        ...newLocationList],
                locationAddressDropdown: lineManagerDropdown,
                hasMoreLocation: locationData.length > 0,
                locationPage: locationPages
            }
        case getRoleDropdown:
            return {
                ...state,
                roleDropdown: action.data
            }
        case resetFetchingHrDetails:
            return{
                ...state, fetchingHrDetails: true
            }
        case setLineManagerLoading:
            return {
                ...state,
                isLineManagerLoading: action.payload
            };
        case setLocationLoading:
            return {
                ...state,
                isLocationLoading: action.payload
            };
        case resetForm:
            return {
                ...state,
                lineManagerDropdownList: [],
                locationAddressDropdownList: [],
                lineManagerDropdown: [],
                locationAddressDropdown: [],
            }
        default:
            return state;
    } 
}